<div
  *ngIf="isLoading"
  class="spinner-overlay d-flex align-items-center justify-content-center"
>
  <div class="spinner"></div>
</div>
